"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendSupportRequest = exports.closeSupportRequestModal = exports.openSupportRequestModal = void 0;

var _apiServices = require("@pingum/api-services");

var types = _interopRequireWildcard(require("./types"));

var _networkDispatcher = require("../networkDispatcher");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var openSupportRequestModal = function openSupportRequestModal() {
  return {
    type: types.OPEN_SUPPORT_REQUEST_MODAL
  };
};

exports.openSupportRequestModal = openSupportRequestModal;

var closeSupportRequestModal = function closeSupportRequestModal() {
  return {
    type: types.CLOSE_SUPPORT_REQUEST_MODAL
  };
};

exports.closeSupportRequestModal = closeSupportRequestModal;

var sendSupportRequest = function sendSupportRequest(newSupportRequest) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.SUPPORT_REQUEST_ADD_REQUESTED,
      successType: types.SUPPORT_REQUEST_ADD_SUCCESS,
      errorType: types.SUPPORT_REQUEST_ADD_ERROR,
      promise: _apiServices.SupportRequestService.sendSupportRequest(newSupportRequest),
      successMessage: 'Request successfully submitted. We will get back to you shortly.',
      defaultErrorMessage: 'There was a problem sending the support request',
      responseName: 'response'
    });
  };
};

exports.sendSupportRequest = sendSupportRequest;